//resetpassword.js
import { useState, useEffect } from "react";
import { updateEmployeePassword, getUserDetails } from "../firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/config";
import "../styles/ResetPassword.css";

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanyId = async () => {
      const uid = auth.currentUser?.uid;
      if (!uid) {
        setError("User not authenticated.");
        return;
      }

      const userDetails = await getUserDetails(uid);
      if (userDetails && userDetails.companyId) {
        setCompanyId(userDetails.companyId);
      } else {
        setError("Company ID not found for this user.");
      }
    };

    fetchCompanyId();
  }, []);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    const uid = auth.currentUser?.uid;
    if (!uid)
      return setError(
        "Your session expired. Please open the invite link again and try setting your password.",
      );

    if (!companyId)
      return setError(
        "We couldn’t verify your company details. Please contact your employer for help.",
      );

    if (newPassword !== confirmPassword)
      if (newPassword !== confirmPassword)
        return setError("Passwords don’t match. Please re-enter them.");

    try {
      await updateEmployeePassword(uid, newPassword, companyId);
      const userDetails = await getUserDetails(uid);

      const { selfOnboarding, profileCompleted } = userDetails || {};
      if (!profileCompleted) {
        // If onboarding is required, send them to the onboarding flow.
        if (selfOnboarding) {
          navigate("/onboarding");
          return;
        }
        // Otherwise the employer must finish it.
        navigate("/profile-pending");
        return;
      }
      // Completed profiles go straight to the dashboard
      navigate("/employee-dashboard");
    } catch (err) {
      setError("We couldn’t update your password. Please try again.");
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-box">
        <h2>Set Your New Password</h2>
        <h2>Finish setting up your account</h2>
        <p className="instruction">
          Your employer created your Oiiko account. Create a password to
          securely access your account.
        </p>
        <p
          className="instruction"
          style={{ marginTop: "-6px", fontSize: "13px", color: "#6b7280" }}
        >
          After this, you’ll be taken to the next step to finish your setup.
        </p>

        <form onSubmit={handleResetPassword} className="reset-form">
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Create a password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span
              className="toggle-visibility"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>

          <div className="input-group">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span
              className="toggle-visibility"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
            >
              {showConfirmPassword ? "Hide" : "Show"}
            </span>
          </div>
          <button type="submit" className="reset-button">
            Create new Password
          </button>

          {error && <p className="error-text">{error}</p>}
        </form>
      </div>
    </div>
  );
}
